import {
    AppState,
    Auth0Provider,
    withAuthenticationRequired,
} from '@auth0/auth0-react';
import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';

import { isAuth0Enabled } from './AuthFirewallProvider.helpers';

const ProtectedChildren = withAuthenticationRequired(
    ({ children }: PropsWithChildren) => children,
);

/**
 * AuthFirewallProvider
 *
 * @param { children } - Child node
 * @returns
 */
const AuthFirewallProvider = ({ children }: PropsWithChildren) => {
    const navigate = useNavigate();

    const onRedirectCallback = (appState?: AppState) => {
        if (appState?.returnTo) navigate(appState.returnTo, { replace: true });
    };

    return (
        <Auth0Provider
            domain={import.meta.env.VITE_AUTH0_DOMAIN}
            clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
            authorizationParams={{
                redirect_uri: window.location.origin,
                scope: 'openid email profile https://api.easeltv.com/tenants',
            }}
            useRefreshTokens
            onRedirectCallback={onRedirectCallback}
        >
            <ProtectedChildren>{children}</ProtectedChildren>
        </Auth0Provider>
    );
};

export default isAuth0Enabled
    ? AuthFirewallProvider
    : ({ children }: PropsWithChildren) => children;
